module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-1.9c2d3546.jpg";